import { useQuery } from '@tanstack/react-query'
import templateInvoiceApi from 'api/templateInvoiceApi'
import { INVOICE_CLASSIFY } from 'general/constants/AppConstants'
import ToastHelper from 'general/helpers/ToastHelper'
import { useAppSelector } from 'hooks/useRedux'
import _ from 'lodash'
import { useMemo } from 'react'

/**
 *
 * @param {'POS' | 'ALL' | 'PXK' | 'HD,MTT'} type
 * @returns
 */
export default function useGetSerials(type, categoryTaxType, getYearCurrent) {
  const systemType = useAppSelector((s) => s.auth.activeInvoice)
  const params = useMemo(() => {
    switch (type) {
      case 'ALL':
        return {
          invoiceClassify: 'ALL',
          getYearCurrent,
        }
      case 'MTT':
      case 'POS':
        return {
          categoryTaxType,
          // categoryForm: 1,
          invoiceClassify: 'MTT',
          getYearCurrent,
        }
      case 'HD,MTT':
        return {
          invoiceClassify: 'HD,MTT',
          getYearCurrent,
        }
      case 'PXK':
        return {
          invoiceClassify: 'PXK',
          getYearCurrent,
        }
      default:
        return { getYearCurrent } // Trường hợp không hợp lệ
    }
  }, [categoryTaxType, type, getYearCurrent])

  return useQuery({
    staleTime: 1000 * 60,
    enabled: systemType.invoice,
    queryKey: ['serials', params, getYearCurrent],
    queryFn: async ({ signal }) => {
      const res = await templateInvoiceApi.getTemplateSerials(params, signal)
      console.log('paramsdata', params)
      if (res?.data.length === 0) {
        if (
          params?.invoiceClassify?.split(',').includes(INVOICE_CLASSIFY.MTT) &&
          window.location.pathname.includes('/may-tinh-tien')
        ) {
          ToastHelper.showError(
            'Bạn chưa thực hiện đăng ký mẫu hóa đơn hoặc không được phân quyền sử dụng mẫu hóa đơn nào. Hãy thực hiện đăng ký trước khi lập hóa đơn',
          )
        } else if (
          params?.invoiceClassify == INVOICE_CLASSIFY.PXK &&
          window.location.pathname.includes('/phieu-xuat-kho')
        ) {
          ToastHelper.showError(
            'Bạn chưa thực hiện đăng ký mẫu hóa đơn hoặc không được phân quyền sử dụng mẫu hóa đơn nào. Hãy thực hiện đăng ký trước khi lập hóa đơn',
          )
        } else if (
          window.location.pathname.includes(
            '/hoa-don-dau-ra/hoa-don/danh-sach-hoa-don',
          ) ||
          window.location.pathname.includes('/hoa-don-dau-ra/hoa-don/them-moi')
        ) {
          ToastHelper.showError(
            'Bạn chưa thực hiện đăng ký mẫu hóa đơn hoặc không được phân quyền sử dụng mẫu hóa đơn nào. Hãy thực hiện đăng ký trước khi lập hóa đơn',
          )
        }
      }
      return res
    },
    select: (res) => {
      return _.isUndefined(res?.data) || _.isNull(res?.data)
        ? []
        : _.concat(
            [{ label: 'Tất cả', value: null }],
            _.map(res?.data, (item) => ({
              ...item,
              label: item.serial,
              value: item.serial,
              invoiceTemplateId: item?.invoiceTemplateId,
              invoiceTemplateName: item?.name,
            })),
          )
    },
  })
}
